import { Routes } from '@angular/router';
import { IsAuthenticatedGuard } from '@app/auth/guards/is-authenticated.guard';
import { ErrorComponent } from '@app/error/error.component';

import { IsSuperadminGuard } from './auth/guards/is-superadmin.guard';

export default [
    { path: 'auth', loadChildren: () => import('./auth/auth-routes') },
    {
        canActivate: [IsAuthenticatedGuard],
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard-routes'),
    },
    {
        path: 'admin',
        canActivate: [IsAuthenticatedGuard, IsSuperadminGuard],
        loadChildren: () => import('./superadmin/superadmin-routes'),
    },
    { path: 'print', outlet: 'print', loadChildren: () => import('./print/print-routes') },
    { path: 'error', component: ErrorComponent },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth',
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'error',
    },
] satisfies Routes;
